import { ModelInstance, BaseModel, ToFrontHook, ToBackHook, listField } from './util';
import { TournamentTeam } from './tournament-team';
import { TournamentGroup } from './tournament-group';

@ModelInstance({
  mappingFields: {
    id: 'id',
    team_id: 'teamId',
    competitor_team_id: 'competitorTeamId',
    team_score: 'teamScore',
    competitor_team_score: 'competitorTeamScore',
  }
})
export class StageTeamGame extends BaseModel {
  id: number;
  teamId: number;
  competitorTeamId: number;
  teamScore: number;
  competitorTeamScore: number;

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}


@ModelInstance({
  mappingFields: {
    id: 'id',
    tournament_team: 'tournamentTeam',
    group: 'group',
    tournament_stage_id: 'tournamentStageId',
    games_count: 'gamesCount',
    won_games_count: 'wonGamesCount',
    score_sum: 'scoreSum',
    missed_sum: 'missedSum',
    last_games_count: 'lastGamesCount',
    last_games_won: 'lastGamesWon',
    points: 'points',
    mt_points: 'mtPoints',
    final_standing: 'finalStanding',
    received_points: 'receivedPoints',
    received_mt_points: 'receivedMtPoints',
    tries_scored: 'triesScored',
    tries_missed: 'triesMissed',
    attack_bonuses: 'attackBonuses',
    defense_bonuses: 'defenseBonuses',
    games: 'games',
    draw_games_count: 'drawGamesCount',
    lose_games_count: 'loseGamesCount',
  },
  relation: {
    tournamentTeam: TournamentTeam,
    group: TournamentGroup,
    games: listField(StageTeamGame),
  }
})
export class TournamentStageTeam extends BaseModel {
  private _games: StageTeamGame[];

  id: number;
  tournamentTeam: TournamentTeam;
  group: TournamentGroup;
  tournamentStageId: number;
  gamesCount: number;
  wonGamesCount: number;
  scoreSum: number;
  missedSum: number;
  lastGamesCount: number;
  lastGamesWon: number;
  points: number;
  mtPoints: number;
  finalStanding: number;
  receivedPoints: number;
  receivedMtPoints: number;
  triesScored: number;
  triesMissed: number;
  attackBonuses: number;
  defenseBonuses: number;
  drawGamesCount: number;
  loseGamesCount: number;
  gamesMapping: {[key: number]: StageTeamGame[]} = {};

  set games(value: StageTeamGame[]) {
    this._games = value;
    this.gamesMapping = value.reduce((acc, game) => {
      const competitorTeamId = game.teamId === this.tournamentTeam.team.id ? game.competitorTeamId : game.teamId;
      return {
        ...acc,
        [competitorTeamId]: [
          ...(acc[competitorTeamId] || []),
          game,
        ]
      };
    }, {});
  }

  get games(): StageTeamGame[] {
    return this._games;
  }

  get gamesWonPercent(): number {
    if (!this.gamesCount) {
      return 0;
    }
    return Math.floor(1000 * this.wonGamesCount / this.gamesCount) / 10;
  }

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
